import PropTypes from 'prop-types';
import styled from 'styled-components';
import Link from '@splunk/react-ui/Link';
import NoDataDark from '../../../assets/images/nodata_dark.svg';
import NoDataLight from '../../../assets/images/nodata_light.svg';

const StyledNoDataMessageBlock = styled.div`
    display: flex;
    align-items: end;
    justify-content: center;
    padding-bottom: 10px;
`;

const StyledNoDataMessageContainer = styled.p`
    .sf-bootstrap & {
        margin: 0;
    }
`;

const StyledNoDataMessageText = styled.span`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
`;

const StyledNoDataMessageLink = styled(Link)`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
`;

export default function NoDataMessage(props) {
    const { message, link, linkText, themeKey = '' } = props;

    return (
        <StyledNoDataMessageBlock className="sf-absolute-fill">
            <img src={themeKey === 'dark' ? NoDataDark : NoDataLight} />
            <StyledNoDataMessageContainer>
                <StyledNoDataMessageText>{message}</StyledNoDataMessageText>
                {link && linkText && (
                    <StyledNoDataMessageLink to={link} openInNewContext rel="noopener noreferrer">
                        {linkText}
                    </StyledNoDataMessageLink>
                )}
            </StyledNoDataMessageContainer>
        </StyledNoDataMessageBlock>
    );
}

NoDataMessage.propTypes = {
    message: PropTypes.string,
    link: PropTypes.string,
    linkText: PropTypes.string,
    themeKey: PropTypes.string,
};
